import { render, staticRenderFns } from "./ColoredStockNumber.vue?vue&type=template&id=2144a84d&functional=true"
import script from "./ColoredStockNumber.vue?vue&type=script&lang=ts"
export * from "./ColoredStockNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports